import axios from './index'

class login {
  //获取验证码
  static outWxlogin(options) {
    return axios.post('/nice-api-customer/v1/login', options)
  }

  //存在code获得授权openID
  static authorizeUrl(options) {
    return axios.get('/nice-api-customer/v1/login/authorizeUrl', {params:options})
  }

  //存在code获得授权openID
  static getAUthUrl(options) {
    return axios.get('/nice-api-customer/v1/login/wxUserInfo', {params:options})
  }

  // wxUserInfo
  
  //发送验证码
  static sendSms(options) {
    return axios.post(`/nice-api-customer/v1/login/sendSms`,options)
  }

  //微信解绑
  static unbindWechat(options) {
    return axios.post(`/nice-api-customer/v1/login/wxExit`)
  }
  
  //根据OPENID登录
  static wxOpenIdLogin(wxOpenId) {
    return axios.post(`/nice-api-customer/v1/login/${wxOpenId}`)
  }
  
  //转短连接
  static sortUrl(url) {
    return axios.get(`nice-api-customer/v1/login/shortUrl?longUrl=${url}`)
  }
  //分享备用方案开关
  static codeConfig(url) {
    return axios.get(`nice-api-curing-service/v1/AppletUseConfSwitch?confUse=appletToH5Switch`)
  }
  

}

export default login;
